import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '../auth/current-user.service';

export const permissionGuard: CanActivateFn = (route, state) => {
  const permission = route.data['permission'];
  const currentUser = inject(CurrentUserService);
  const router = inject(Router);
  const isOwner = currentUser.isBusinessOwner() ||
    (currentUser.user()?.roles ?? [currentUser.user()?.role ?? ''])
      .some((role) => role.toLowerCase().startsWith('businessowner') || role.toLowerCase() === 'owner');
  const isSuperAdmin = (currentUser.user()?.roles ?? [currentUser.user()?.role ?? ''])
    .some((role) => role === 'SuperAdmin' || role === 'PlatformSuperAdmin');

  const allowed = isOwner || isSuperAdmin || (Array.isArray(permission)
    ? permission.some((code) => typeof code === 'string' && currentUser.hasPermission(code))
    : typeof permission !== 'string' || currentUser.hasPermission(permission));

  if (allowed) {
    return true;
  }

  return router.createUrlTree([
    state.url.startsWith('/business') ? currentUser.businessLandingRoute() : '/admin/dashboard',
  ]);
};
